import { render, staticRenderFns } from "./details-datasource.vue?vue&type=template&id=5343f052&"
import script from "./details-datasource.vue?vue&type=script&lang=js&"
export * from "./details-datasource.vue?vue&type=script&lang=js&"
import style0 from "./details-datasource.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports